<template>
  <div class="container">
    <div class="container-680">
      <div id="slideShow" class="carousel slide carousel-fade">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#slideShow" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#slideShow" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#slideShow" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../assets/processing.jpg" class="d-block w-100" alt="pompier">
            <div class="carousel-caption d-none d-md-block">
              <h5>Une pression minimum nécessaire</h5>
              <p>Lors de l’utilisation des bornes incendies par les forces de secours, la pression doit rester au minimum à un bar ou 10 mCE.</p>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/processing2.jpg" class="d-block w-100" alt="pompier">
            <div class="carousel-caption d-none d-md-block">
              <!-- <h5>Second slide label</h5> -->
              <p>Naega DI permet, pour chaque nœud du réseau, un calcul automatisé de la pression au débit que vous souhaitez (60 m3/h ou autre) à 20h (généralement l’heure de pointe), pour un fichier Epanet démarrant à 0h. A chaque nœud, la demande incendie modélisée s'ajoute à la demande existante du modèle.</p>
            </div>
          </div>
          <div class="carousel-item">
            <img src="../assets/Extrait_naega.jpg" class="d-block w-100" alt="extrait naega">
            <div class="carousel-caption d-none d-md-block">
              <!-- <h5>Third slide label</h5> -->
              <p>Pour aller plus loin, la plateforme Naega : gestion des ressources en eau, prospective urbaine, gestion patrimoniale, scénarios d’impact urbains</p>
            </div>
          </div>
        </div>
        <!-- <button class="carousel-control-prev" type="button" data-bs-target="#slideShow" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#slideShow" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button> -->
      </div>
    </div>
    <div class="animation-waiting">
      <div v-if="!jobSucceeded && position <= 0" class="spinner" aria-hidden="true"></div>
      <div v-if="jobSucceeded">
        <lottie-animation
            :path=lottieUrl
            :loop="false"
            :autoPlay="true"
            :width="96"
            :height="96"
        />
      </div>
    </div>
    <p v-if="position > 0" class="text-white fw-bold text-center mt-4">Votre position dans la liste d'attente :  <span class="text-30">{{ position }}</span></p>
    <p v-else class="text-white fw-bold text-center mt-4">Vos données sont en cours de traitement, veuillez patienter s’il vous plaît...</p>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue'
import { Carousel } from 'bootstrap'

export default {
  name: 'Processing',
  components: {
    LottieAnimation
  },
  props: {
    jobSucceeded: Boolean,
    fileName: String,
    position: Number
  },
  data () {
    return {
      lottieUrl: './' + process.env.BASE_URL + 'done.json'
    }
  },
  mounted () {
    const myCarousel = document.querySelector('#slideShow')
    const carousel = new Carousel(myCarousel, {
      interval: 3000,
      ride: 'carousel',
      hover: false
    })
    carousel.cycle()
  }
}
</script>

<style scoped>
.carousel {
  margin-top: 3.75rem;
  padding-bottom: 4rem;
}

.carousel-inner {
  overflow: visible;
}

.carousel-item img {
  border-radius: .625rem;
}

.carousel-caption {
  background-color: var(--white);
  color: var(--text-black);
  text-align: start;
  padding: 1.875rem;
  border-radius: .625rem;
  position: absolute;
  bottom: -4rem;
  z-index: 10;
}

.carousel-indicators [data-bs-target] {
  background-color: var(--white);
  border: 1px solid var(--black);
  opacity: 1;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 .25rem;
}

.carousel-indicators [data-bs-target].active {
  background-color: var(--black);
}

.file-infos {
  display: flex;
  font-size: .75rem;
  align-items: center;
  justify-content: space-between;
}

.alert-danger {
  color: var(--text-black);
  background-color: var(--alert-danger);
  border-color: var(--alert-danger);
}

.animation-waiting {
  display: flex;
  justify-content: center;
  margin: 2.875rem auto 1.25rem;
}

.spinner {
  position: static;
  width: 4.5rem;
  height: 4.5rem;
  margin: .75rem 0;
  border-width: .5rem;
  border-color: rgba(255, 255, 255, .1);
  border-top-color: var(--white);
}
</style>
